import { IObject } from 'types';

export type FiasSelection = {
  /** Группы домов (`fias.selectedGroups`) */
  groups: IObject[];
  /** Улицы, посёлки, города и другие объекты (`fias.selectedFias`) */
  fias: IObject[];
  /** Дома (`fias.selectedHouses`) */
  houses: IObject[];
};

// Поиск улицы, на которой находится дом
export const searchStreet = (
  items: IObject[],
  house: IObject
): IObject | null => {
  let result = null;

  items.some((item: IObject): boolean => {
    if (item.AOGUID === house.parent) {
      result = item;

      return true;
    }

    if (item.inheritors) {
      result = searchStreet(item.inheritors, house);

      return result !== null;
    }

    return false;
  });

  return result;
};

/**
 * Собирает бейджи выбранных адресов: группы и объекты ФИАС как есть,
 * дома вкладываются в свою улицу (`selectedHouses`) — так же, как в FiasSearch.
 */
export const buildSelectedItems = (
  { groups, fias, houses }: FiasSelection,
  tree: IObject[]
): IObject[] => {
  const params: IObject[] = [...groups, ...fias, ...houses];

  // Разделение домов и остальных выбранных объектов
  let notLastLvlParams: IObject[] = [];
  const lastLvlParams: IObject[] = params.filter((item: IObject): boolean => {
    if (!item.houses && !item.inheritors) {
      return true;
    }

    notLastLvlParams.push(item);

    return false;
  });

  // Вкладывание домов в улицу в случае их наличия среди выбранных
  lastLvlParams.forEach((house: IObject) => {
    const street: IObject | null = searchStreet(tree, house);

    // Улица дома не найдена в дереве — показываем дом отдельным бейджем
    if (!street) {
      notLastLvlParams.push(house);

      return;
    }

    const existingItem: IObject | undefined = notLastLvlParams.find(
      (item: IObject) => item.AOGUID && item.AOGUID === street.AOGUID
    );

    // Замена существующего объекта на объект со вложенными домами
    if (existingItem) {
      const newItem: IObject = {
        ...existingItem,
        selectedHouses: [...(existingItem.selectedHouses || []), house],
      };

      notLastLvlParams = notLastLvlParams.map(
        (item: IObject): IObject =>
          item.AOGUID && item.AOGUID === newItem.AOGUID ? newItem : item
      );

      return;
    }

    // Добавление объекта со вложенными домами в случае его отсутствия
    notLastLvlParams.push({ ...street, selectedHouses: [house] });
  });

  return lastLvlParams.length ? notLastLvlParams : params;
};
